"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4646],{

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Renders the <head> section of the HTML page, including meta tags, title, and favicon.
 * @param ogImage - The URL of the Open Graph image to be displayed in social media shares.
 * @param title - The title of the page.
 * @param description - The description of the page.
 */ const Head = (param)=>{
    let { ogImage ="https://www.dnld.us/images/audocs-bkg-web-1050.png" , title ="audi0 | NFT" , description ="DNLD for NFT"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:determiner",
                content: "the"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: "DNLD Rewards"
            })
        ]
    });
};


/***/ }),

/***/ 33808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MobileActivityFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60430);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30758);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59417);
/* harmony import */ var components_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18491);






const MobileActivityFilters = (param)=>{
    let { activityTypes , setActivityTypes  } = param;
    const filters = [
        {
            type: "sale",
            name: "Sales",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faShoppingCart */ .sq$
        },
        {
            type: "ask",
            name: "Listings",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTag */ .LEN
        },
        {
            type: "bid",
            name: "Offers",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faHand */ .ioV
        },
        {
            type: "transfer",
            name: "Transfer",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faRightLeft */ .eRx
        },
        {
            type: "mint",
            name: "Mint",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faSeedling */ .YKZ
        }
    ];
    let filtersEnabled = activityTypes.length > 0;
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        justify: "center",
        css: {
            position: "fixed",
            left: 0,
            bottom: "70px",
            width: "100vw",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            css: {
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                position: "fixed",
                px: "$6",
                py: "$3"
            },
            type: "button",
            size: "small",
            corners: "pill",
            color: "gray3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                    style: "h6",
                    children: "Filter"
                }),
                filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                    justify: "center",
                    align: "center",
                    css: {
                        height: "24px",
                        width: "24px",
                        backgroundColor: "$gray4",
                        borderRadius: "100%",
                        fontSize: "medium",
                        fontWeight: "500"
                    },
                    children: activityTypes.length
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_3__/* .FullscreenModal */ .O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                css: {
                    flexDirection: "column",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        css: {
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4"
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                        style: "h5",
                                        css: {
                                            mr: "$3"
                                        },
                                        children: "Filter"
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                        justify: "center",
                                        css: {
                                            height: "24px",
                                            width: "24px",
                                            backgroundColor: "$gray3",
                                            borderRadius: "100%",
                                            mr: "$3"
                                        },
                                        children: activityTypes.length
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                        onClick: ()=>{
                                            setActivityTypes([]);
                                        },
                                        color: "ghost",
                                        size: "small",
                                        css: {
                                            color: "$primary11",
                                            fontWeight: 400
                                        },
                                        children: "Clear all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faXmark */ .g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        direction: "column",
                        css: {
                            p: "$4",
                            "& > div:first-of-type": {
                                pt: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                style: "subtitle1",
                                css: {
                                    mb: "$4"
                                },
                                children: "Event Type"
                            }),
                            filters.map((filter)=>{
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    css: {
                                        mb: "$3",
                                        gap: "$3"
                                    },
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                            css: {
                                                color: "$gray11"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                icon: filter.icon,
                                                width: 16,
                                                height: 16
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                            style: "body1",
                                            css: {
                                                flex: 1
                                            },
                                            children: filter.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                            align: "center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Switch */ .rs, {
                                                checked: activityTypes === null || activityTypes === void 0 ? void 0 : activityTypes.includes(filter.type),
                                                onCheckedChange: (checked)=>{
                                                    if (checked) {
                                                        setActivityTypes([
                                                            ...activityTypes,
                                                            filter.type
                                                        ]);
                                                    } else {
                                                        setActivityTypes(activityTypes.filter((item)=>{
                                                            return item != filter.type;
                                                        }));
                                                    }
                                                }
                                            })
                                        })
                                    ]
                                }, filter.name);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 61194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fw": function() { return /* binding */ CollapsibleContent; }
/* harmony export */ });
/* unused harmony exports slideDown, slideUp, Collapsible, AnimatedCollapsibleContent, CollapsibleRoot */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86744);
/* harmony import */ var _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49665);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





const slideDown = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const slideUp = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const CollapsibleContent = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_3__/* .CollapsibleContent */ .Fw, {
    background: "transparent",
    border: "none",
    borderRadius: 0
});
const CollapsibleRoot = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
    borderRadius: 8,
    overflow: "hidden"
});
const AnimatedCollapsibleContent = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return _jsx(CollapsibleContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ _jsx(motion.div, {
            ref: forwardedRef,
            initial: {
                width: 0
            },
            animate: {
                width: "100%",
                transition: {
                    mass: 1,
                    duration: 0.15
                }
            },
            exit: {
                width: 0,
                transition: {
                    duration: 0.3
                }
            },
            children: children
        })
    });
})));
const Collapsible = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(CollapsiblePrimitive.Root, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ _jsx(CollapsiblePrimitive.Trigger, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ _jsx(AnimatePresence, {
                children: open && /*#__PURE__*/ _jsx(AnimatedCollapsibleContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
})));



/***/ }),

/***/ 12623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ DropdownMenuContent; },
/* harmony export */   "Lt": function() { return /* binding */ Dropdown; },
/* harmony export */   "Xi": function() { return /* binding */ DropdownMenuItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31139);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99842);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26718);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21190);





const DropdownMenuContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuContent */ .AW, {
    mx: "$4",
    p: "$2",
    borderRadius: 8,
    zIndex: 5,
    background: "$dropdownBg",
    $$borderColor: "$colors$gray7",
    boxShadow: "0 0 0 1px $$borderColor"
});
const AnimatedDropdownMenuContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownMenuContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            initial: {
                scale: 0.9,
                opacity: 0,
                y: -20
            },
            animate: {
                scale: 1,
                opacity: 1,
                y: 0,
                transition: {
                    mass: 0.05,
                    type: "spring",
                    duration: 0.1
                }
            },
            exit: {
                y: -20,
                scale: 0.9,
                opacity: 0,
                transition: {
                    duration: 0.1
                }
            },
            children: children
        })
    });
});
const DropdownMenuItem = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuItem */ .Xi, {
    fontSize: 16,
    fontFamily: "$body",
    color: "$gray12",
    px: "$2",
    py: "$4",
    borderRadius: 8,
    outline: "none",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "$gray5"
    },
    "&:focus": {
        backgroundColor: "$gray5"
    }
});
const Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .AnimatePresence */ .M, {
                children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimatedDropdownMenuContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
});



/***/ }),

/***/ 53370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SP": function() { return /* binding */ TabsTrigger; },
/* harmony export */   "dr": function() { return /* binding */ TabsList; },
/* harmony export */   "nU": function() { return /* binding */ TabsContent; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36888);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31139);


const TabsList = (0,stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__/* .List */ .aV, {
    display: "flex",
    gap: "$5",
    borderBottom: "1px solid $gray5",
    mt: "$5",
    mb: "$4"
});
const TabsTrigger = (0,stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__/* .Trigger */ .xz, {
    fontWeight: "700",
    pb: "$3",
    '&[data-state="active"]': {
        boxShadow: "inset 0 -2px 0 0 var(--colors-primary9), 0 2px 0 0 var(--colors-primary9)"
    }
});
const TabsContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_radix_ui_react_tabs__WEBPACK_IMPORTED_MODULE_1__/* .Content */ .VY, {});



/***/ }),

/***/ 84205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports basicFetcher, fetchWithTimeout */
/* harmony import */ var _reservoir0x_reservoir_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80514);
/* provided dependency */ var process = __webpack_require__(83454);

const fetcher = async function(url) {
    let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const headers = new Headers();
    if (process.env.NEXT_PUBLIC_RESERVOIR_API_KEY) {
        headers.set("x-api-key", process.env.NEXT_PUBLIC_RESERVOIR_API_KEY);
    }
    const path = new URL(url);
    (0,_reservoir0x_reservoir_sdk__WEBPACK_IMPORTED_MODULE_0__/* .setParams */ .PX)(path, params);
    const response = await fetch(path.href, {
        headers,
        ...data
    });
    const json = await response.json();
    return {
        data: json,
        response
    };
};
const basicFetcher = async (href, options)=>{
    const response = await fetch(href, options);
    const json = await response.json();
    return {
        data: json,
        response
    };
};
const fetchWithTimeout = async (url, options, timeout)=>{
    const controller = new AbortController();
    const signal = controller.signal;
    const timeoutId = setTimeout(()=>controller.abort(), timeout);
    try {
        const response = await fetch(url, {
            ...options,
            signal
        });
        clearTimeout(timeoutId);
        return response;
    } catch (error) {
        if (error instanceof Error) {
            if (error.name === "AbortError") {
                throw new Error("Request timed out");
            }
        }
        throw error;
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (fetcher);


/***/ }),

/***/ 94830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ DATE_REGEX; },
/* harmony export */   "x": function() { return /* binding */ timeTill; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__);


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default()));
/**
 * REGEX to parse out YYYY-MM-DD HH:MM:SS from a raw string
 * @returns YYYY-MM-DD HH:MM:SS
 */ const DATE_REGEX = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/;
/**
 * Returns a human-readable string indicating the time remaining until the provided time string.
 * @param timeString The target time string in the format "YYYY-MM-DD HH:MM:SS".
 * @returns A human-readable string indicating the time remaining until the target time.
 */ const timeTill = (timeString)=>{
    return "".concat(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(timeString).fromNow(true));
};


/***/ })

}]);